import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FireFruits_1Screen } from "../FireFruits/game_1Screen"

// namespace SlotGames {
	export class FireFruitsLink_1Screen extends FireFruits_1Screen {

	
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
			super(multigameParams, initData, "FireFruitsLink");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		}

    }

    
